"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTPInput = void 0;
const react_1 = __importStar(require("react"));
require("./OTPInput.scss");
const OTPInput_scss_json_1 = __importDefault(require("./OTPInput.scss.json"));
const Input_1 = require("@mui/base/Input");
const arr = Array.from({ length: 6 }, () => '');
const idPrefix = 'lincd-input-otp-';
const OTPInput = ({ onClick, isLoading }) => {
    const [number, setNumber] = (0, react_1.useState)(arr);
    const numberToString = number.join('');
    const numberIndex = (0, react_1.useRef)(number || []);
    numberIndex.current = number;
    (0, react_1.useEffect)(() => {
        if (numberToString.length === 6) {
            isLoading(true);
            setTimeout(() => {
                onClick(numberToString);
            }, 500);
        }
    }, [numberToString, onClick]);
    return (react_1.default.createElement("div", { className: OTPInput_scss_json_1.default.container },
        react_1.default.createElement("div", { className: OTPInput_scss_json_1.default.innerContainer }, arr.map((num, index) => {
            return (react_1.default.createElement(Input_1.Input, { value: numberIndex.current[index], onChange: (e) => {
                    var _a;
                    const inputValue = e.target.value;
                    if (/^\d$/.test(inputValue)) {
                        const newNumber = [...number];
                        newNumber[index] = inputValue;
                        setNumber(newNumber);
                        if (index < newNumber.length - 1) {
                            (_a = document.getElementById(`${idPrefix}${index + 1}`)) === null || _a === void 0 ? void 0 : _a.focus();
                        }
                    }
                }, key: index, id: `${idPrefix}${index}`, type: 'number', 
                // if user delete the input, focus on previous input
                onKeyDown: (e) => {
                    var _a;
                    if (e.key === 'Backspace') {
                        const newNumber = [...number];
                        newNumber[index] = '';
                        setNumber(newNumber);
                        (_a = document.getElementById(`${idPrefix}${index - 1}`)) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                } }));
        }))));
};
exports.OTPInput = OTPInput;
//# sourceMappingURL=OTPInput.js.map